<template>
    <BasicDrawer :duration="duration / 1000" ref="basicDrawerRef" v-if="show">
        <template v-slot:header>
            <div class="cancel-button" @click="closeDrawer">取消</div>

            <div class="header-title">
                <div class="title-label">按区县选择</div>
            </div>

            <div class="confirm-button" @click="confirm">完成({{ checkAddress.length }}/100)</div>
        </template>

        <template>
            <div class="county-box">
                <div class="county-box_left">
                    <div
                        :class="[
                            'province-item',
                            { 'is-check': currentProvince === item.code, 'is-check-child': getChildCheck(item.children) },
                        ]"
                        v-for="item in addressJson"
                        :key="item.code"
                        @click="handleChangeArea(1, item)"
                    >
                        {{ item.name }}
                    </div>
                </div>

                <div class="county-box_center">
                    <div
                        :class="['city-item', { 'is-check': currentCity === item.code }]"
                        v-for="item in getCityList"
                        :key="item.code"
                        @click="handleChangeArea(2, item)"
                    >
                        {{ item.name }}

                        <div class="check-count" v-if="getCheckCount(item) > 0">{{ getCheckCount(item) }}</div>
                    </div>
                </div>

                <div class="county-box_right">
                    <div
                        :class="['county-item', { 'is-check': checkAddress.includes(item.code) }]"
                        v-for="item in getCountyList"
                        :key="item.code"
                        @click="handleCheckCounty(item)"
                    >
                        <div class="county-item_label">{{ item.name }}</div>
                        <div class="check-icon"><i class="iconfont">&#xe63b;</i></div>
                    </div>
                </div>
            </div>
        </template>
    </BasicDrawer>
</template>

<script>
import BasicDrawer from "./BasicDrawer.vue";
import pcas from "@/utils/training-data/pcas.json";

export default {
    name: "TimeChangeDrawer",
    components: {
        BasicDrawer,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        checkList: {
            type: Array,
            required: true,
        },
        duration: {
            type: Number,
            default: 180,
        },
    },
    data() {
        return {
            checkAddress: [],
            addressList: [],
            currentProvince: undefined,
            currentCity: undefined,
            addressJson: [],
        };
    },
    created() {
        this.addressJson = this.formatterArea(JSON.parse(JSON.stringify(pcas)));
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.checkAddress = JSON.parse(JSON.stringify(this.checkList));
            }
        },
    },
    computed: {
        // 城市列表
        getCityList() {
            const provinceItem = this.addressJson.find((item) => item.code === this.currentProvince);

            if (provinceItem) {
                return provinceItem.children || [];
            }

            return [];
        },

        // 获取区县列表
        getCountyList() {
            const provinceItem = this.addressJson.find((item) => item.code === this.currentProvince);

            if (provinceItem) {
                const cityItem = provinceItem.children.find((item) => item.code === this.currentCity);

                if (cityItem) {
                    return cityItem.children || [];
                }
            }

            return [];
        },
    },
    methods: {
        // 格式化地区json数据，去除第四级
        formatterArea(area) {
            for (let i = 0; i < area.length; i++) {
                const areaItem = area[i];

                if (!this.currentProvince && areaItem.level === 1) {
                    this.currentProvince = areaItem.code;
                } else if (!this.currentCity && areaItem.level === 2) {
                    this.currentCity = areaItem.code;
                }

                if (areaItem.level === 4) return false;

                if (areaItem.children && areaItem.children.length > 0) {
                    if (!this.formatterArea(areaItem.children)) {
                        delete areaItem.children;
                    }
                }
            }

            return area;
        },

        // 修改地区
        handleChangeArea(type, area) {
            if (type === 1) {
                const cityList = this.addressJson.find((item) => item.code === area.code).children || [];
                if (cityList.length > 0) {
                    this.currentCity = cityList[0].code;
                }

                this.currentProvince = area.code;
            } else if (type === 2) {
                this.currentCity = area.code;
            }
        },

        // 选择区县
        handleCheckCounty(county) {
            if (this.checkAddress.length >= 100) return;

            const checkCountyIndex = this.checkAddress.findIndex((item) => item === county.code);

            if (checkCountyIndex !== -1) {
                this.checkAddress.splice(checkCountyIndex, 1);
            } else {
                this.checkAddress.push(county.code);
            }
        },

        // 该城市选中了多少
        getCheckCount(city) {
            const countyList = city.children || [];

            return (countyList.filter((city) => this.checkAddress.includes(city.code)) || []).length;
        },

        // 该省份下是否有区县被选中
        getChildCheck(areaList) {
            for (let i = 0; i < areaList.length; i++) {
                const areaItem = areaList[i];

                if (areaItem.children && areaItem.children.length > 0) {
                    const isCheck = areaItem.children.some((item) => this.checkAddress.includes(item.code));

                    if (isCheck) return true;
                }
            }

            return false;
        },

        closeDrawer() {
            if (this.$refs.basicDrawerRef) {
                this.$refs.basicDrawerRef.hiddenDrawer();
            }

            setTimeout(() => {
                this.$emit("close");

                this.currentProvince = this.addressJson[0].code;
                this.currentCity = this.addressJson[0].children[0].code;
            }, this.duration);
        },

        confirm() {
            this.$emit("confirm", this.checkAddress);

            this.closeDrawer();
        },
    },
};
</script>

<style scoped lang="scss">
* {
    font-family: PingFang-SC;
}

::v-deep .drawer-box_header {
    font-size: 13px;
    color: #323233;
    font-weight: 600;

    .header-title {
        text-align: center;

        .title-tip {
            font-weight: 500;
            color: #999999;
            font-size: 12px;
            margin-top: 2px;
        }
    }

    .cancel-button,
    .confirm-button {
        width: 73px;
        cursor: pointer;
    }

    .confirm-button {
        color: #fc2b55;
        flex-shrink: 0;
        font-size: 13px;
        text-wrap: nowrap;
    }
}

::v-deep .drawer-box_content {
    padding: 0 !important;

    .county-box {
        height: 400px;
        display: flex;

        &_left,
        &_center,
        &_right {
            flex-shrink: 0;
            height: 100%;
            overflow: auto;
            scrollbar-width: none;

            &::-webkit-scrollbar {
                display: none;
            }
        }

        .province-item,
        .city-item {
            padding: 12px 0 12px 12px;
            box-sizing: border-box;
            font-size: 12px;
            white-space: nowrap; /* 强制单行显示 */
            overflow: hidden; /* 超出部分隐藏 */
            text-overflow: ellipsis; /* 显示省略号 */
            position: relative;
            cursor: pointer;
            position: relative;
        }

        &_left {
            width: calc((100% - ((100% / 3) + 20px)) / 2);
            background-color: #ffffff;

            .province-item {
                padding-right: 14px;

                &.is-check {
                    background-color: #f8f8f8;
                    color: #fc2b55;

                    &::before {
                        content: "";
                        position: absolute;
                        width: 2px;
                        background-color: #fc2b55;
                        left: 0;
                        top: 0;
                        bottom: 0;
                    }
                }

                &.is-check-child {
                    &::after {
                        position: absolute;
                        content: "";
                        width: 6px;
                        height: 6px;
                        background-color: #fc2b55;
                        border-radius: 50%;
                        right: 4px;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }
            }
        }

        &_center {
            width: calc((100% - ((100% / 3) + 20px)) / 2);
            background-color: #f8f8f8;

            .city-item {
                &.is-check {
                    background-color: #f3f3f3;
                    color: #fc2b55;
                }

                .check-count {
                    position: absolute;
                    top: 5px;
                    right: 2px;
                    width: 16px;
                    height: 16px;
                    background-color: #fc2b55;
                    color: #ffffff;
                    font-size: 10px;
                    border-radius: 50%;
                    text-align: center;
                    line-height: 16px;
                }
            }
        }

        &_right {
            width: calc((100% / 3) + 20px);
            background-color: #f3f3f3;

            .county-item {
                padding: 12px 16px 12px 16px;
                box-sizing: border-box;
                font-size: 12px;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 10px;

                &_label {
                    white-space: nowrap; /* 强制单行显示 */
                    overflow: hidden; /* 超出部分隐藏 */
                    text-overflow: ellipsis; /* 显示省略号 */
                    width: calc(100% - 24px);
                }

                .check-icon {
                    border-radius: 50%;
                    width: 14px;
                    height: 14px;
                    border: 1px solid #dddddd;
                    display: flex;
                    align-items: center;

                    .iconfont {
                        background-color: #ffffff;
                        color: #fc2b55;
                        border-radius: 50%;
                        display: none;
                    }
                }

                &.is-check {
                    .check-icon {
                        border-color: #fc2b55;
                    }

                    .iconfont {
                        display: block;
                    }
                }
            }
        }
    }
}
</style>
